import Tick from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Tick24PxOutlined";
import styles from "./IncludedGuarantees.module.scss";
import classNames from "classnames";

type Props = {
  /**
   * An array of objects, each having a title property of type string.
   */
  guarantees: { title: string }[];
};

export const IncludedGuaranteesUI = ({ guarantees }: Props) => (
  <div data-testid="product:included-guarantees">
    <ul
      data-testid="product:included-guarantees:list"
      className={classNames(styles.list, {
        [styles.mobileGalleryExperience]: false, // TODO: !!mobileGalleryExperience,
      })}
    >
      {guarantees.map(({ title }, index) => {
        return (
          <li className={styles.item} key={`guarantee-${index}`}>
            <Tick />
            <p
              data-testid="product:included-guarantees:title"
              className={styles.title}
            >
              {title}
            </p>
          </li>
        );
      })}
    </ul>
  </div>
);
